import styled from 'styled-components';
import { darken, rgba } from 'polished';

const THEME_COLOR = '#6b63d5';

export const Container = styled.div<{ headerHeight: string }>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: calc(100vh - ${props => props.headerHeight});
  padding: 24px;
  background: #f5f5f5;
`;

export const FormContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px ${rgba('#000', 0.08)};
  width: 100%;
  max-width: 800px;
  overflow: hidden;
`;

export const FormHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid ${rgba('#000', 0.08)};

  h2 {
    font-size: 1.25rem;
    color: ${darken(0.4, THEME_COLOR)};
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;

    i {
      font-size: 1.5rem;
      color: ${THEME_COLOR};
    }
  }
`;

export const FormBody = styled.div`
  padding: 24px;
`;

export const FormFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${rgba('#000', 0.08)};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: ${rgba('#000', 0.02)};
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
  gap: 16px;

  .MuiCircularProgress-root {
    color: ${THEME_COLOR};
  }

  p {
    color: ${rgba('#000', 0.6)};
    margin: 0;
  }
`;